import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";


const HeroSection = ({data}:{data: WebsitePageSection}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
    >
      <div className="flex relative flex-col gap-4 bg-[#F2F2F2] w-full border rounded border-gray-50 overflow-hidden">
        <img src={data.fileUrl ?? "/blank-image-placeholder.png"} alt={data.title ?? "Hero Section"} className="w-full object-cover h-full object-center max-h-96 xl:max-h-[30rem]" />
      </div>
    </EditableSection>
  )
}

export default HeroSection